import React, { useState, useEffect, useContext } from "react"
import { Link } from "react-router-dom"
import request from "request"

import { ApplicationContext } from "ApplicationContext"
import Header from "Header"
import AsyncContainer from "AsyncContainer"

const App8Integration = () => {
  const { CurrentUserContext } = useContext(ApplicationContext)
  const { venue } = CurrentUserContext

  const [isLoaded, setIsLoaded] = useState(false)
  const [stats, setStats] = useState(null)

  useEffect(() => {
    let mounted = true
    request.get("/venue_admin/integrations/app8_stats")
      .then(({ data }) => {
        if (!mounted) return
        setStats(data.app8)
        setIsLoaded(true)
      })
      .catch(() => mounted && setIsLoaded(true))
    return () => { mounted = false }
  }, [venue])

  const hasData = stats && stats.totalInflows > 0

  return (
    <div>
      <AsyncContainer isLoaded={isLoaded}>

        {/* Logo + title bar */}
        <div className="level mb-5">
          <div className="level-left">
            <div className="level-item">
              <img
                src="/images/integrations/app8.svg"
                alt="App8"
                style={{ height: 36, marginRight: 16 }}
              />
            </div>
            <div className="level-item">
              <div>
                <p className="subtitle is-6 mb-0">Mobile ordering integration</p>
              </div>
            </div>
            {hasData && (
              <div className="level-item">
                <span className="tag is-success">Active</span>
              </div>
            )}
          </div>
        </div>

        {/* Stats — only when there are inflows */}
        {hasData && (
          <div className="columns mb-5">
            {[
              { label: "Last Order Received", value: stats.lastInflowAt ? new Date(stats.lastInflowAt).toLocaleString() : "Never" },
              { label: "Orders (last 30 days)", value: stats.ordersLast30Days },
              { label: "Inflows (last 30 days)", value: stats.inflowsLast30Days },
              { label: "Total Inflows", value: stats.totalInflows },
            ].map(({ label, value }) => (
              <div className="column" key={label}>
                <div className="box has-text-centered" style={{ padding: "1rem" }}>
                  <p className="heading mb-1">{label}</p>
                  <p className="is-size-6 has-text-weight-medium">{value}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Setup instructions — when no inflows yet */}
        {!hasData && (
          <div className="box">
            <p className="title is-6 mb-4">Connect App8</p>

            <div className="notification is-info is-light mb-4">
              <p>
                App8 sends orders directly to Catch using your venue's API key.
                No additional configuration is needed here — just create an API key and share it with App8.
              </p>
            </div>

            <div className="content">
              <ol>
                <li>
                  Go to <Link to="/api-keys"><strong>API Keys</strong></Link> and create a new key.
                </li>
                <li>
                  Share the API key with your App8 account manager.
                </li>
                <li>
                  App8 will configure their system to send orders to your Catch venue.
                </li>
                <li>
                  Once orders start flowing in, stats will appear on this page.
                </li>
              </ol>
            </div>
          </div>
        )}

        {/* How it works */}
        <div className="box mt-4">
          <p className="title is-6 mb-3">How it works</p>
          <div className="content is-small">
            <ol>
              <li>App8 sends order payloads to Catch via the <code>POST /api/v1/orders/app8</code> endpoint.</li>
              <li>Each order is automatically created as a completed cash order for reporting purposes.</li>
              <li>Products and modifiers are matched by name or auto-created from the payload.</li>
              <li>All incoming payloads are stored as Inflow records for auditing.</li>
              <li>Orders appear in your regular reports alongside other sales.</li>
            </ol>
          </div>
        </div>

      </AsyncContainer>
    </div>
  )
}

export default App8Integration
